import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';


import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatBadgeModule } from '@angular/material/badge';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MAT_TOOLTIP_DEFAULT_OPTIONS, MatTooltipDefaultOptions, MatTooltipModule } from '@angular/material/tooltip';


export const myTooltipDefaults: MatTooltipDefaultOptions = {
  showDelay: 700,
  hideDelay: 0,
  touchendHideDelay: 1500
};

@NgModule({
  declarations: [],
  providers: [
    { provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: myTooltipDefaults }
  ],
  imports: [
    CommonModule,
    MatCheckboxModule,
    MatInputModule,
    MatFormFieldModule,
    MatSidenavModule,
    MatGridListModule,
    MatListModule,
    MatCardModule,
    MatMenuModule,
    MatToolbarModule,
    MatSlideToggleModule,
    MatIconModule,
    MatExpansionModule,
    MatDialogModule,
    MatNativeDateModule,
    MatBottomSheetModule,
    MatSelectModule,
    MatSnackBarModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatBadgeModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    MatTooltipModule,
    MatRadioModule,
    MatButtonToggleModule
  ],
  exports: [
    MatButtonModule,
    MatCheckboxModule,
    MatInputModule,
    MatFormFieldModule,
    MatSidenavModule,
    MatGridListModule,
    MatListModule,
    MatCardModule,
    MatMenuModule,
    MatBottomSheetModule,
    MatToolbarModule,
    MatSlideToggleModule,
    MatIconModule,
    MatExpansionModule,
    MatDialogModule,
    MatNativeDateModule,
    MatSelectModule,
    MatSnackBarModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatBadgeModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatRadioModule,
    ScrollingModule,
    MatButtonToggleModule
  ]
})
export class MaterialModule {
  constructor(/*library: FaIconLibrary*/) {
    // library.addIcons(
    //   faImages,
    //   faBatteryEmpty,
    //   faBatteryQuarter,
    //   faBatteryHalf,
    //   faBatteryThreeQuarters,
    //   faBatteryFull,
    //   faAppleAlt,
    //   faCircle
    //   );
  }
}
